module.exports = __webpack_public_path__ + "img/bg.ntsa.16b77631.jpg";